/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Modal, Typography } from '@telus-uds/components-web';
// import EmailShare from 'react-email-share-link';
import PropTypes from 'prop-types';
import styles from '../../assets/css/style';
import { css } from 'styled-components';
import Help from '../help';
import request from '../utils/request';
import {
  localeEnglish,
  localeFrench,
  wirelessOrderForm
} from '../utils/constant';
import { useLocaleActionsContext } from '../context/LocaleContext';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import EN from '../../EN.json';
import FR from '../../FR.json';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';
import { localeEn, localeFr } from '../misc';
import history from '../history';

const onClickLogout = () => {
  localStorage.clear();
  window.location.reload();
};

const Menu = ({ locale, userRights, profile }) => {
  const setLocale = useLocaleActionsContext();
  const localizedStrings = useLocalizedStringsContext();
  const [isModalOpen, setModalOpen] = useState(false);
  const [showHelpSection, setShowHelpSection] = useState(false);
  const ischangePassword = localStorage.getItem('changePassword') === 'true';
  const provinceValue =
    localStorage.getItem('province') === 'AB' ||
    localStorage.getItem('province') === 'BC';

  const config = {
    ...contentfulFormConfig,
    content_type: 'header',
    locale
  };

  // eslint-disable-next-line
  const [helpLink, setHelpLink] = useState('');
  const {
    switchLocaleModal: {
      modalTitle,
      modalBody,
      modalConfirmButtonLabel,
      modalCancelButtonLabel
    },
  } = localizedStrings;
  const {
    headerLinks: { home, help, reportAnIssue, labelLogout }
  } = locale === 'en-US' ? EN : FR;

  const changeLocale = () => {
    setLocale(locale === localeEn ? localeFr : localeEn);
  };
  const onConfirm = () => {
    setModalOpen(false);
    changeLocale();
    history.push('/');
  };

  const onCloseModal = () => setModalOpen(false);

  useEffect(() => {
    getContentfulData(config)
      .then(res => {
        const headerData = getData(res);
        const link = _.get(headerData, 'helpPdf.fields.file.url', '');
        setHelpLink(link);
        if (
          provinceValue &&
          !history.location.pathname.includes(wirelessOrderForm)
        ) {
          setLocale(localeEn);
        }
      })
      .catch(() => { });
  }, [locale, provinceValue]);

  const focusElementOnClose = useRef(null);
  const [count, setCount] = useState(0);
  const roleId = _.get(profile, 'role.id', '');
  const fetchNotificationCount = async () => {
    if (roleId === 1) {
      await request.get('/defects/countnotify-admin').then(res => {
        const {
          data: { notificationCount = '' }
        } = res;
        if (notificationCount >= 0) {
          setCount(notificationCount);
        }
      });
    } else {
      const profileId = _.get(profile, 'id')
      if (profileId) {
        await request.get(`/defects/countnotify-user/${profileId}`).then(res => {
          const {
            data: { notificationCount = '' }
          } = res;
          if (notificationCount >= 0) {
            setCount(notificationCount);
          }
        });
      }
    }
  }
  useEffect(() => {
    fetchNotificationCount()
  })
  return (
    <>
      {userRights && !ischangePassword && (
        <ul style={{
          justifyContent: 'flex-end',
          flex: '1 1 0%',
          listStyle: 'none',
        }}>
          {userRights.isHomeLinkVisible && (
            <li>
              <Link variant="link" to="/">
                <Typography variant={{ inverse: true }}>{home}</Typography>
              </Link>
            </li>
          )}
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link href="#" onClick={() => setShowHelpSection(true)}>
              <Typography variant={{ inverse: true }}>{help}</Typography>
            </Link>
          </li>
          <li>
            <Link to={`/${locale}/report-an-issue`}><Typography variant={{ inverse: true }}>{reportAnIssue}</Typography>
              {" "}
              {count > 0 ? (
                <sup>
                  <span
                    className="badge badge-pill badge-danger"
                    style={{
                      fontSize: '0.7rem',
                      padding: '0.2em 0.45em',
                      minWidth: '1.25em',
                      lineHeight: 1.2,
                      verticalAlign: 'middle'
                    }}
                  >
                    {count}
                  </span>
                </sup>
              ) : (
                ''
              )}</Link>
          </li>
          {locale === localeFrench ? (
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link href="#" onClick={() => setLocale(localeEnglish)}>
                <Typography variant={{ inverse: true }}>English</Typography>
              </Link>
            </li>
          ) : (
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link href="#" onClick={() => setLocale(localeFrench)}>
                <Typography variant={{ inverse: true }}>Français</Typography>
              </Link>
            </li>
          )}
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link href="#" onClick={onClickLogout}>
              <Typography variant={{ inverse: true }}>{labelLogout}</Typography>
            </Link>
          </li>
        </ul>
      )}
      <Modal
        /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
        heading={modalTitle}
        bodyText={modalBody}
        confirmButtonText={modalConfirmButtonLabel}
        cancelButtonText={modalCancelButtonLabel}
        onConfirm={onConfirm}
        onClose={onCloseModal}
        isOpen={isModalOpen}
      />
      {showHelpSection && (
        <Help guideLink={helpLink} setShowHelpSection={setShowHelpSection} />
      )}
    </>
  );
};

Menu.propTypes = {
  locale: PropTypes.string.isRequired,
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool,
    isHomeLinkVisible: PropTypes.bool
  }).isRequired
};
/* eslint-disable react/prop-types */
export default Menu;
